import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';

export class AbstractVisionKey extends BasicEntity {
chronoCode: string;
code: string;
level: number | null;
levelCode: string;
order: number | null;
visionCode: string;
}

